export const GROUP_TYPE_FIELD = 'group';
export const INFRASTRUCTURE_CBQOS = 'CBQoS';
export const THRESHOLDS_QUERY_KEY_TYPE = 'type';
export const THRESHOLDS_TAB_INFRA = 'infrastructure';
export const THRESHOLDS_TAB_SERVICE = 'service-tests';
export const DEFAULT_SERVICE_GROUP = 'Web';

export const CBQOS_OPTION_ENABLED_STATUS = 'enabled-status';
export const CBQOS_OPTION_ENABLED_NO_STATUS = 'enabled-no-status';
export const CBQOS_OPTION_DISABLED = 'disabled';
export const CBQOS_OPTIONS = [
    { name: 'Enabled', value: CBQOS_OPTION_ENABLED_STATUS, monitor: true, status: true },
    { name: 'Enabled, no Status', value: CBQOS_OPTION_ENABLED_NO_STATUS, monitor: true, status: false },
    { name: 'Disabled', value: CBQOS_OPTION_DISABLED, monitor: false, status: false },
];
